import {
  depthToShortestTitleDoubleElim,
  depthToShortestTitleSingleElim,
} from "model/Bracket/BracketTitles";

export type BracketemPointsRules =
  | number
  | {
      depth: number[];
      lowerDepth: number[] | undefined;
      grandFinal: number | undefined;
    };

export const getBracketemPointsRulesText = (rules: BracketemPointsRules) => {
  if (typeof rules === "number") {
    return `${rules} points are awarded for each correct pick.`;
  }

  let rulesText = "Points are awarded for each correct prediction as follows: ";
  if (!!rules.grandFinal) {
    rulesText += `GF - ${rules.grandFinal} points, `;
  }

  const maxDepth = rules.depth.length;
  if (!!rules.lowerDepth && rules.lowerDepth.length > 0) {
    const maxLowerDepth = rules.lowerDepth.length;
    rulesText += rules.depth
      .map(
        (points, i) =>
          `${depthToShortestTitleDoubleElim(
            i + 1,
            maxDepth,
            false
          )} - ${points} points`
      )
      .join(", ");
    rulesText += ", ";
    rulesText += rules.lowerDepth
      .map(
        (points, i) =>
          `${depthToShortestTitleDoubleElim(
            i + 1,
            maxLowerDepth,
            true
          )} - ${points} points`
      )
      .join(", ");
  } else {
    rulesText += rules.depth
      .map(
        (points, i) =>
          `${depthToShortestTitleSingleElim(
            i + 1,
            maxDepth
          )} - ${points} points`
      )
      .join(", ");
  }

  return rulesText;
};
